/** Initials avatar – pink/lime gradient circle. Falls back to upload pic if provided. */
export default function Avatar({ src, name = "?", size = 80, className = "" }) {
  const initials = (name || "?")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .split(/\s+/)
    .map(s => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase() || "?";

  const style = { width: size, height: size, fontSize: size * 0.38 };

  if (src) {
    return (
      <img src={src} alt={name} style={style}
        className={`rounded-full object-cover ring-2 ring-neon-lime/60 shadow-[0_0_24px_rgba(16,185,129,0.4)] ${className}`}
        data-testid="avatar-image" />
    );
  }
  return (
    <div style={style}
      className={`relative rounded-full overflow-hidden flex items-center justify-center font-heading font-medium text-[#1A1A1A] shadow-[0_0_28px_rgba(16,185,129,0.45)] ring-2 ring-white/20 ${className}`}
      data-testid="avatar-initials"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-neon-pink via-fuchsia-500 to-neon-lime opacity-95" />
      <span className="relative z-10 drop-shadow">{initials}</span>
    </div>
  );
}
